<template>
  <div>
    <v-container fluid class="pb-0" v-show="!loading">
      <v-card>

        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Recebimento de Comissões</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.push('/comissoes')" :disabled="salvando" class="hidden-xs-only">Cancelar</v-btn>
          <v-btn fab small @click="$router.push('/comissoes')" :disabled="salvando" class="hidden-sm-and-up">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn depressed :loading="salvando" :disabled="salvando || !form_valid" @click="salvar" color="primary lighten-4" class="hidden-xs-only ml-2">Salvar</v-btn>
          <v-btn fab small :loading="salvando" :disabled="salvando || !form_valid" @click="salvar" color="primary lighten-4" class="hidden-sm-and-up ml-2">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-app-bar>

        <v-form v-show="!loading" ref="form" v-model="form_valid" lazy-validation>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-autocomplete
                  v-model="recebimento.cliente_id"
                  :items="clientes"
                  label="Cliente *"
                  ref="cliente"
                  item-text="responsavel_nome"
                  item-value="id"
                  @change="carregarPedidoAbertos"
                  :rules="regras.cliente"
                  :disabled="$route.params.id ? true : false"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <as-date-picker-menu ref="data" label="Data *" v-model="recebimento.data" :rules="regras.data" color="primary"></as-date-picker-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select :items="formas_pagamento" label="Forma de Pagamento *" ref="forma_pagamento" v-model="recebimento.forma_pagamento" :rules="regras.forma_pagamento"></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2">
                <v-text-field
                  :value="valor_total_comissoes_abertos | valorBR"
                  readonly
                  hide-details
                  label="Pedidos Abertos"
                  type="text"
                >
                  <template v-slot:append>
                    <v-chip
                      label
                      color="primary"
                      text-color="white"
                      class="mb-1 px-3"
                      style="height: 24px"
                    >
                      <b>{{ pedidos_abertos.length }}</b>
                    </v-chip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  :value="valor_total_comissoes_pagos | valorBR"
                  readonly
                  hide-details
                  label="Pedidos Pagos"
                  type="text"
                >
                  <template v-slot:append>
                    <v-chip
                      label
                      color="primary"
                      text-color="white"
                      class="mb-1 px-3"
                      style="height: 24px"
                    >
                      <b>{{ pedidos_pagos.length }}</b>
                    </v-chip>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

      </v-card>
    </v-container>

    <v-container fluid v-show="!loading">
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card>
            <v-app-bar color="primary" flat dark dense>
              <v-toolbar-title>Pedidos em Aberto</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="tooglePesquisaPedidosAbertos">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-app-bar>

            <v-expand-transition>
              <div
                v-show="exibirPesquisaPedidosAbertos"
                class="pa-2"
                style="background-color: rgba(189, 189, 189, 0.3);"
              >
                <v-text-field
                  ref="pesquisaPedidosAbertos"
                  label="Pesquisa"
                  v-model="pesquisaPedidosAbertos"
                  prepend-inner-icon="search"
                  solo
                  clearable
                  single-line
                  hide-details
                  placeholder="Pesquisa"
                  color="primary"
                  @click:clear="tooglePesquisaPedidosAbertos"
                ></v-text-field>
              </div>
            </v-expand-transition>

            <v-data-table
              :search="pesquisaPedidosAbertos"
              :headers="headers"
              :items="pedidos_abertos"
              :loading="loading_pedidos_abertos"
              no-data-text="Sem registros"
              no-results-text="Sem registros"
              loading-text="Carregando dados..."
              sort-by="id"
              hide-default-footer
              :items-per-page="-1"
            >
              <template v-slot:item.acoes="{ item }">
                <td class="text-xs-center">
                  <v-btn icon @click="adicionarPedidoPago(item)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </td>
              </template>
              <template v-slot:item.valor="{ item }">
                <td>{{ item.valor | valorBR }}</td>
              </template>
              <template v-slot:item.comissao_valor="{ item }">
                <td>{{ item.comissao_valor | valorBR }}</td>
              </template>

              <template v-slot:body.append v-if="pedidos_abertos.length > 0 && $vuetify.breakpoint.smAndUp">
                <td colspan="4"></td>
                <td>
                  <b>{{ valor_total_abertos | valorBR }}</b>
                </td>
                <td>
                  <b>{{ valor_total_comissoes_abertos | valorBR }}</b>
                </td>
              </template>

            </v-data-table>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-card>
            <v-app-bar color="primary" flat dark dense>
              <v-toolbar-title>Pedidos Pagos</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="tooglePesquisaPedidosPagos">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-app-bar>

            <v-expand-transition>
              <div
                v-show="exibirPesquisaPedidosPagos"
                class="pa-2"
                style="background-color: rgba(189, 189, 189, 0.3);"
              >
                <v-text-field
                  ref="pesquisaPedidosAbertos"
                  label="Pesquisa"
                  v-model="pesquisaPedidosPagos"
                  prepend-inner-icon="search"
                  solo
                  clearable
                  single-line
                  hide-details
                  placeholder="Pesquisa"
                  color="primary"
                  @click:clear="tooglePesquisaPedidosPagos"
                ></v-text-field>
              </div>
            </v-expand-transition>

            <v-data-table
              :search="pesquisaPedidosPagos"
              :headers="headers"
              :items="pedidos_pagos"
              :loading="loading"
              no-data-text="Sem registros"
              no-results-text="Sem registros"
              loading-text="Carregando dados..."
              sort-by="id"
              hide-default-footer
              :items-per-page="-1"
            >
              <template v-slot:item.acoes="{ item }">
                <td class="text-xs-center">
                  <v-btn icon @click="removerPedidoPago(item)">
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </td>
              </template>
              <template v-slot:item.valor="{ item }">
                <td>{{ item.valor | valorBR }}</td>
              </template>
              <template v-slot:item.comissao_valor="{ item }">
                <td>{{ item.comissao_valor | valorBR }}</td>
              </template>

              <template v-slot:body.append v-if="pedidos_pagos.length > 0 && $vuetify.breakpoint.smAndUp">
                <td colspan="4"></td>
                <td>
                  <b>{{ valor_total_pagos | valorBR }}</b>
                </td>
                <td>
                  <b>{{ valor_total_comissoes_pagos | valorBR }}</b>
                </td>
              </template>

            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-row v-show="loading">
      <v-col
        class="ma-6 pa-6"
        style="display: flex; align-items: center; justify-content: center; text-align: center"
      >
        <v-progress-circular size="64" indeterminate color="primary"></v-progress-circular>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ServiceClientes from '@/services/clientes.js';
import ServicePedidos from '@/services/pedidos.js';
import ServiceRecebimentos from '@/services/recebimentos.js';
export default {
  name: 'ComissoesForm',
  data () {
    return {
      loading: false,
      loading_pedidos_abertos: false,
      salvando: false,
      form_valid: false,
      exibirPesquisaPedidosAbertos: false,
      exibirPesquisaPedidosPagos: false,
      pesquisaPedidosAbertos: '',
      pesquisaPedidosPagos: '',
      user: {},
      clientes: [],
      recebimento: {
        cliente_id: '',
        data: '',
        forma_pagamento: '',
      },
      formas_pagamento: [
        'Boleto',
        'Cheque',
        'Crédito',
        'Débito',
        'Depósito',
        'Pix',
        'Transferência'
      ],
      pedidos_abertos: [],
      headers: [
        { text: "", value: "acoes", width: "5%", sortable: false, align: "center" },
        { text: "Número", value: "id", width: "5%", align: "left" },
        { text: "Loja", value: "cliente_loja_nome", width: "30%" },
        { text: "Local", value: "local", width: "30%" },
        { text: "Valor", value: "valor", width: "15%" },
        { text: "Comissão", value: "comissao_valor", width: "15%" },
      ],
      pedidos_pagos: [],
      regras: {
        cliente: [value => !!value || 'Campo obrigatório'],
        data: [value => !!value || 'Campo obrigatório'],
        forma_pagamento: [value => !!value || 'Campo obrigatório']
      },
      rodada: {}
    }
  },
  mounted () {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.rodada = JSON.parse(localStorage.getItem("rodada")) || [];
    this.carregarClientes();

    if (this.$route.params.id) {
      this.editar();
    } else {
      this.recebimento.data = new Date().toJSON().slice(0,10);
    }
  },
  methods: {
    tooglePesquisaPedidosAbertos () {
      this.exibirPesquisaPedidosAbertos = !this.exibirPesquisaPedidosAbertos;
      if (this.exibirPesquisaPedidosAbertos) {
        setTimeout(() => {
          this.$refs.pesquisaPedidosAbertos.focus();
        }, 0);
      }
    },
    tooglePesquisaPedidosPagos () {
      this.exibirPesquisaPedidosPagos = !this.exibirPesquisaPedidosPagos;
      if (this.exibirPesquisaPedidosPagos) {
        setTimeout(() => {
          this.$refs.pesquisaPedidosPagos.focus();
        }, 0);
      }
    },
    async carregarClientes () {
      this.loading = true;
      try {
        let clientes_response = await ServiceClientes.carregarClientesRepresentante(this.user.representante_id);
        this.clientes = clientes_response.data.clientes;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro('Erro ao carregar clientes');
      } finally {
        this.loading = false;
      }
    },
    async carregarPedidoAbertos () {
      try {
        this.loading_pedidos_abertos = true;
        let rodada_id = 0;
        if(Object.prototype.hasOwnProperty.call(this.rodada, 'id')){
          rodada_id = this.rodada.id;
        }
        let pedidos_response = await ServicePedidos.carregarPedidosAbertos(this.recebimento.cliente_id, rodada_id);
        this.pedidos_abertos = pedidos_response.data.pedidos_abertos;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro('Erro ao carregar pedidos');
      } finally {
        this.loading_pedidos_abertos = false;
      }
    },
    adicionarPedidoPago (pedido_selecionado) {
      let indice = this.pedidos_abertos.indexOf(pedido_selecionado);
      let pedido = this.clone(pedido_selecionado);
      this.pedidos_pagos.unshift(pedido);
      this.pedidos_abertos.splice(indice, 1);
    },
    removerPedidoPago (pedido_selecionado) {
      let indice = this.pedidos_pagos.indexOf(pedido_selecionado);
      let pedido = this.clone(pedido_selecionado);
      this.pedidos_abertos.unshift(pedido);
      this.pedidos_pagos.splice(indice, 1);
    },
    async salvar () {
      if (this.$refs.form.validate()) {
        if (this.pedidos_pagos.length > 0) {
          try {
            this.salvando = true;
            this.recebimento.pedidos_quantidade = this.pedidos_pagos.length;
            this.recebimento.valor_total = this.valor_total_comissoes_pagos;
            let post = {
              recebimento: this.recebimento,
              pedidos_pagos: this.pedidos_pagos
            };

            if (this.$route.params.id) {
              await ServiceRecebimentos.atualizar(this.$route.params.id, post);
              this.$eventbus.notificar('Recebimento atualizado com sucesso');
            } else {
              await ServiceRecebimentos.salvar(post);
              this.$eventbus.notificar('Recebimento salvo com sucesso');
            }
            this.$router.push('/comissoes');
          } catch (error) {
            console.log(error);
            this.$eventbus.erro(error.response.data.msg);
          } finally {
            this.salvando = false;
          }
        } else {
          this.$eventbus.erro('Você deve selecionar pelo menos um pedido para pagamento');
        }
      }
    },
    async editar () {
      try {
        this.loading = true;

        let recebimento_response = await ServiceRecebimentos.editar(this.$route.params.id);
        this.recebimento = recebimento_response.data.recebimento;
        this.pedidos_pagos = recebimento_response.data.pedidos_pagos;

        this.carregarPedidoAbertos();

      } catch (error) {
        console.log(error);
        this.$eventbus.erro('Erro ao editar recebimento');
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    valor_total_abertos () {
      return this.pedidos_abertos.reduce((soma, pedido) => {
        return soma + pedido.valor;
      }, 0);
    },
    valor_total_comissoes_abertos () {
      return this.pedidos_abertos.reduce((soma, pedido) => {
        return soma + pedido.comissao_valor;
      }, 0);
    },
    valor_total_pagos () {
      return this.pedidos_pagos.reduce((soma, pedido) => {
        return soma + pedido.valor;
      }, 0);
    },
    valor_total_comissoes_pagos () {
      return this.pedidos_pagos.reduce((soma, pedido) => {
        return soma + pedido.comissao_valor;
      }, 0);
    }
  }
}
</script>

<style>
  
</style>